import { render, staticRenderFns } from "./TermView.vue?vue&type=template&id=060b1fee&scoped=true"
import script from "./TermView.vue.js?vue&type=script&lang=js&external"
export * from "./TermView.vue.js?vue&type=script&lang=js&external"
import style0 from "./TermView.vue?vue&type=style&index=0&id=060b1fee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b1fee",
  null
  
)

export default component.exports